import { render, staticRenderFns } from "./NoPermissionPage.vue?vue&type=template&id=f9d4195a&scoped=true&"
var script = {}
import style0 from "./NoPermissionPage.vue?vue&type=style&index=0&id=f9d4195a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d4195a",
  null
  
)

export default component.exports